var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMainsettings24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_mainsettings24x24",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "settings_2_",
    d: "M18.326,9.257H16.8c-.358,0-.538-.268-.538-.626a.464.464,0,0,1,.179-.358L17.519,7.2a.762.762,0,0,0,0-1.162h0L16.175,4.7a.767.767,0,0,0-1.165,0L13.934,5.771a.686.686,0,0,1-.448.179c-.179,0-.269-.089-.448-.179a.682.682,0,0,1-.179-.447V3.8a.8.8,0,0,0-.807-.8H10.17a.827.827,0,0,0-.9.8v1.52a.6.6,0,0,1-.538.626h0a.686.686,0,0,1-.448-.179L7.212,4.7a.767.767,0,0,0-1.165,0L4.7,6.039A.762.762,0,0,0,4.7,7.2h0L5.778,8.274a.563.563,0,0,1,0,.8c-.179.089-.269.179-.448.179H3.807a.8.8,0,0,0-.807.8v1.877a.826.826,0,0,0,.807.894H5.33c.358,0,.538.268.538.626a.464.464,0,0,1-.179.358L4.613,14.888a.762.762,0,0,0,0,1.162h0l1.344,1.341a.767.767,0,0,0,1.165,0L8.2,16.318a.686.686,0,0,1,.448-.179.67.67,0,0,1,.627.536h0V18.2a.8.8,0,0,0,.807.8h1.882a.8.8,0,0,0,.807-.8v-1.52a.516.516,0,0,1,.538-.536h0c.179,0,.269.089.448.179l1.075,1.073a.767.767,0,0,0,1.165,0L17.34,16.05a.762.762,0,0,0,0-1.162h0l-1.075-1.073a.563.563,0,0,1,0-.8.68.68,0,0,1,.358-.179h1.524a.8.8,0,0,0,.807-.8V10.151A.637.637,0,0,0,18.326,9.257Zm-5.2,1.788a2.061,2.061,0,1,1-2.061-2.056A2.025,2.025,0,0,1,13.127,11.045Z",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMainsettings24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_mainsettings24x24.3e6eb7b18b11acc33668f6092e32f6e9.svg";